import { type SVGProps } from "react";

// Icons from the onboarding Figma ("Icon / megaphone", "Icon / store", ...),
// drawn from the design's own stroke paths. They stroke with currentColor, so
// CSS sets the colour.
type IconData = { size: number; strokeWidth: number; paths: string[] };

const ICONS = {
  trending: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M18.3333 5.83333L11.25 12.9167L7.08333 8.75L1.66667 14.1667",
      "M13.3333 5.83333H18.3333V10.8333",
    ],
  },
  megaphone: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M2.5 9.16667L17.5 5V15L2.5 11.6667V9.16667Z",
      "M9.66667 14C9.57912 14.3174 9.42992 14.6144 9.22759 14.8741C9.02525 15.1338 8.77375 15.3511 8.48744 15.5136C8.20112 15.6761 7.88561 15.7806 7.5589 15.8212C7.23219 15.8617 6.90069 15.8375 6.58333 15.75C6.26597 15.6625 5.96896 15.5133 5.70926 15.3109C5.44956 15.1086 5.23226 14.8571 5.06975 14.5708C4.90725 14.2845 4.80273 13.9689 4.76217 13.6422C4.7216 13.3155 4.74579 12.984 4.83333 12.6667",
    ],
  },
  store: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M2.5 7.5L3.75 3.33333H16.25L17.5 7.5",
      "M2.5 7.5H17.5V8.33333C17.5 8.99637 17.2366 9.63226 16.7678 10.1011C16.2989 10.5699 15.663 10.8333 15 10.8333C14.337 10.8333 13.7011 10.5699 13.2322 10.1011C12.7634 9.63226 12.5 8.99637 12.5 8.33333C12.5 8.99637 12.2366 9.63226 11.7678 10.1011C11.2989 10.5699 10.663 10.8333 10 10.8333C9.33696 10.8333 8.70107 10.5699 8.23223 10.1011C7.76339 9.63226 7.5 8.99637 7.5 8.33333C7.5 8.99637 7.23661 9.63226 6.76777 10.1011C6.29893 10.5699 5.66304 10.8333 5 10.8333C4.33696 10.8333 3.70107 10.5699 3.23223 10.1011C2.76339 9.63226 2.5 8.99637 2.5 8.33333V7.5Z",
      "M4.16667 10.8333V17.5H15.8333V10.8333",
      "M8.33333 17.5V14.1667H11.6667V17.5",
    ],
  },
  target: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z",
      "M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10Z",
      "M11.6667 10C11.6667 10.9205 10.9205 11.6667 10 11.6667C9.07953 11.6667 8.33333 10.9205 8.33333 10C8.33333 9.07953 9.07953 8.33333 10 8.33333C10.9205 8.33333 11.6667 9.07953 11.6667 10Z",
    ],
  },
  chart: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M2.5 2.5V17.5H17.5",
      "M15 14.1667V7.5",
      "M10.8333 14.1667V4.16667",
      "M6.66667 14.1667V11.6667",
    ],
  },
  palette: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M12.5 5.41667C12.5 6.10702 11.9404 6.66667 11.25 6.66667C10.5596 6.66667 10 6.10702 10 5.41667C10 4.72631 10.5596 4.16667 11.25 4.16667C11.9404 4.16667 12.5 4.72631 12.5 5.41667Z",
      "M15.8333 8.75C15.8333 9.44036 15.2737 10 14.5833 10C13.893 10 13.3333 9.44036 13.3333 8.75C13.3333 8.05964 13.893 7.5 14.5833 7.5C15.2737 7.5 15.8333 8.05964 15.8333 8.75Z",
      "M8.33333 6.25C8.33333 6.94036 7.77369 7.5 7.08333 7.5C6.39298 7.5 5.83333 6.94036 5.83333 6.25C5.83333 5.55964 6.39298 5 7.08333 5C7.77369 5 8.33333 5.55964 8.33333 6.25Z",
      "M6.66667 10.4167C6.66667 11.107 6.10702 11.6667 5.41667 11.6667C4.72631 11.6667 4.16667 11.107 4.16667 10.4167C4.16667 9.72631 4.72631 9.16667 5.41667 9.16667C6.10702 9.16667 6.66667 9.72631 6.66667 10.4167Z",
      "M10 1.66667C5.41667 1.66667 1.66667 5.41667 1.66667 10C1.66667 14.5833 5.41667 18.3333 10 18.3333C10.75 18.3333 11.4167 17.6667 11.4167 16.9167C11.4167 16.5833 11.25 16.25 11.0833 16C10.8333 15.75 10.75 15.4167 10.75 15.0833C10.75 14.3333 11.4167 13.6667 12.1667 13.6667H13.3333C15.9167 13.6667 18 11.5833 18 9C18.3333 5 14.5833 1.66667 10 1.66667Z",
    ],
  },
  briefcase: {
    size: 20,
    strokeWidth: 1.66667,
    paths: [
      "M3.33333 5.83333H16.6667C17.5871 5.83333 18.3333 6.57953 18.3333 7.5V15.8333C18.3333 16.7538 17.5871 17.5 16.6667 17.5H3.33333C2.41286 17.5 1.66667 16.7538 1.66667 15.8333V7.5C1.66667 6.57953 2.41286 5.83333 3.33333 5.83333Z",
      "M13.3333 17.5V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H8.33333C7.89131 2.5 7.46738 2.67559 7.15482 2.98816C6.84226 3.30072 6.66667 3.72464 6.66667 4.16667V17.5",
    ],
  },
  heart: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M11.0833 8.16667C11.9525 7.315 12.8333 6.29417 12.8333 4.95833C12.8333 4.10743 12.4953 3.29138 11.8936 2.6897C11.292 2.08802 10.4759 1.75 9.625 1.75C8.59833 1.75 7.875 2.04167 7 2.91667C6.125 2.04167 5.40167 1.75 4.375 1.75C3.5241 1.75 2.70805 2.08802 2.10637 2.6897C1.50469 3.29138 1.16667 4.10743 1.16667 4.95833C1.16667 6.3 2.04167 7.32083 2.91667 8.16667L7 12.25L11.0833 8.16667Z",
    ],
  },
  message: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M12.25 8.75C12.25 9.05942 12.1271 9.35616 11.9083 9.57496C11.6895 9.79375 11.3928 9.91667 11.0833 9.91667H4.08333L1.75 12.25V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H11.0833C11.3928 1.75 11.6895 1.87292 11.9083 2.09171C12.1271 2.3105 12.25 2.60725 12.25 2.91667V8.75Z",
    ],
  },
  eye: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M1.16667 7C1.16667 7 2.91667 2.91667 7 2.91667C11.0833 2.91667 12.8333 7 12.8333 7C12.8333 7 11.0833 11.0833 7 11.0833C2.91667 11.0833 1.16667 7 1.16667 7Z",
      "M8.75 7C8.75 7.9665 7.9665 8.75 7 8.75C6.0335 8.75 5.25 7.9665 5.25 7C5.25 6.0335 6.0335 5.25 7 5.25C7.9665 5.25 8.75 6.0335 8.75 7Z",
    ],
  },
  link: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M5.83333 7.58333C6.08385 7.91824 6.40346 8.19536 6.77049 8.39588C7.13752 8.59641 7.54338 8.71565 7.96055 8.74553C8.37771 8.7754 8.79643 8.71521 9.18829 8.56904C9.58014 8.42286 9.93598 8.19412 10.2317 7.89833L11.9817 6.14833C12.513 5.59824 12.8069 4.86149 12.8003 4.09675C12.7937 3.33201 12.4869 2.60047 11.9461 2.0597C11.4054 1.51892 10.6738 1.21218 9.90909 1.20553C9.14435 1.19889 8.40759 1.49287 7.8575 2.02417L6.85417 3.02167",
      "M8.16667 6.41667C7.91615 6.08176 7.59654 5.80464 7.22951 5.60412C6.86248 5.40359 6.45662 5.28435 6.03945 5.25447C5.62229 5.2246 5.20357 5.28479 4.81171 5.43096C4.41986 5.57714 4.06402 5.80588 3.76833 6.10167L2.01833 7.85167C1.48704 8.40176 1.19306 9.13851 1.1997 9.90325C1.20635 10.668 1.51309 11.3995 2.05386 11.9403C2.59464 12.4811 3.32617 12.7878 4.09091 12.7945C4.85565 12.8011 5.59241 12.5071 6.1425 11.9758L7.14 10.9783",
    ],
  },
  search: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M11.0833 6.41667C11.0833 8.994 8.994 11.0833 6.41667 11.0833C3.83934 11.0833 1.75 8.994 1.75 6.41667C1.75 3.83934 3.83934 1.75 6.41667 1.75C8.994 1.75 11.0833 3.83934 11.0833 6.41667Z",
      "M12.25 12.25L9.74167 9.74167",
    ],
  },
  package: {
    size: 14,
    strokeWidth: 1.16667,
    paths: [
      "M4.375 2.49083L9.625 5.495",
      "M12.25 4.66667C12.2498 4.46208 12.1958 4.26114 12.0934 4.08401C11.991 3.90688 11.8438 3.75979 11.6667 3.6575L7.58333 1.32417C7.40598 1.22177 7.20479 1.16786 7 1.16786C6.79521 1.16786 6.59402 1.22177 6.41667 1.32417L2.33333 3.6575C2.15615 3.75979 2.00899 3.90688 1.9066 4.08401C1.80422 4.26114 1.75021 4.46208 1.75 4.66667V9.33333C1.75021 9.53792 1.80422 9.73886 1.9066 9.91599C2.00899 10.0931 2.15615 10.2402 2.33333 10.3425L6.41667 12.6758C6.59402 12.7782 6.79521 12.8321 7 12.8321C7.20479 12.8321 7.40598 12.7782 7.58333 12.6758L11.6667 10.3425C11.8438 10.2402 11.991 10.0931 12.0934 9.91599C12.1958 9.73886 12.2498 9.53792 12.25 9.33333V4.66667Z",
      "M1.925 4.08333L7 7L12.075 4.08333",
      "M7 12.8333V7",
    ],
  },
  "arrow-left": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M8 12.6667L3.33333 8L8 3.33333", "M12.6667 8H3.33333"],
  },
  "arrow-right": {
    size: 16,
    strokeWidth: 1.33333,
    paths: ["M3.33333 8H12.6667", "M8 3.33333L12.6667 8L8 12.6667"],
  },
  check: {
    size: 12,
    strokeWidth: 1,
    paths: ["M10 3L4.5 8.5L2 6"],
  },
} satisfies Record<string, IconData>;

export type OnboardingIconName = keyof typeof ICONS;

type OnboardingIconProps = {
  name: OnboardingIconName;
  // Rendered size in px; defaults to the size it was drawn at in Figma.
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "name">;

export function OnboardingIcon({ name, size, ...props }: OnboardingIconProps) {
  const icon: IconData = ICONS[name];
  const renderedSize = size ?? icon.size;
  return (
    <svg
      width={renderedSize}
      height={renderedSize}
      viewBox={`0 0 ${icon.size} ${icon.size}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={icon.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}>
      {icon.paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
